import axios from 'axios'
import { TransitOperationLogResponse } from '../../../../api/models'
import { TransitOperationLogFunctionalErrorResponse } from '../../../../api/models/transit-operation-log-functional-error-response'

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/transit-operation-log`

export async function fetchTransitOperationLogsV2(transitOperationId: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios
    .get<TransitOperationLogResponse[]>(`${baseUrl}/transit-operation/${transitOperationId}`, {
    signal: opts?.signal,
  })

  return data
}

export async function fetchTransitOperationLogDetailsV2(logId: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios
    .get<TransitOperationLogFunctionalErrorResponse[]>(`${baseUrl}/${logId}/details`, {
    signal: opts?.signal,
  })

  return data
}

export async function fetchSubmitMessageLog(params: {
  logId: number
  messageType: string
}) {
  return await axios
    .get<TransitOperationLogResponse[]>(
    `${baseUrl}/${params.logId}/download`,
    {
      params: {
        messageType: params.messageType,
      },
      responseType: 'blob',
    },
  )
}
